import React from "react";
import ConnectToInternet from "../../reusable/ConnectToInternet";
import BlackTitleBar from "../getwifius/BlackTitleBar";
import GetSimPricing from "./GetSimPricing";
import GetSimSubNavi from "../../reusable/GetSimSubNavi";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import AnyQuestions from "../../reusable/AnyQuestions";

class GetSim extends React.Component {
  render() {
    return (
      <div>
        <ConnectToInternet />
        {/* <BlackTitleBar /> */}
        <GetSimSubNavi />
        <GetSimPricing />
        <AnyQuestions />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(GetSim);



// WEBPACK FOOTER //
// ./src/pages/getsim/index.js